import DevelopmentProjectsPageContainer from './containers/DevelopmentProjectsPageContainer'

export default DevelopmentProjectsPageContainer
